import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import { Logo } from '../../../base/Logo';
import { Link } from './Navigation';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link href="#hero">
              <Logo textColorClassName="text-white" />
            </Link>
            <p className="mt-4 text-gray-400">
              {t('footer.description')}
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{t('footer.product.title')}</h3>
            <ul className="space-y-2">
              <li><a href="#features" className="hover:text-white transition-colors">{t('footer.product.features')}</a></li>
              <li><a href="#pricing" className="hover:text-white transition-colors">{t('footer.product.pricing')}</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{t('footer.support.title')}</h3>
            <ul className="space-y-2">
              <li><a href="#faq" className="hover:text-white transition-colors">{t('footer.support.helpCenter')}</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">{t('footer.support.contactUs')}</a></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} THESAI. {t('footer.copyright')}
          </div>
          
          <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-8 items-center">
            <div className="flex items-center">
              <Mail className="h-5 w-5 mr-2 text-gray-400" />
              <a href="mailto:contact@thesai.ai" className="hover:text-white transition-colors">
                contact@thesai.ai
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
